import { ArrowRight, MessageCircle, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LeadActions({
  labels,
  contact,
  quoteHref = "/contact#quote-request",
  prefix = "lead-actions",
  className = "",
}) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`.trim()}>
      <Button
        asChild
        className="h-11 rounded-full bg-accent px-6 text-accent-foreground shadow-lg shadow-orange-200 transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-accent/90"
        data-testid={`${prefix}-quote-button`}
      >
        <a href={quoteHref}>
          {labels.requestQuote}
          <ArrowRight className="h-4 w-4" />
        </a>
      </Button>

      <Button
        asChild
        variant="secondary"
        className="h-11 rounded-full border border-primary/15 bg-primary text-primary-foreground transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-primary/90"
        data-testid={`${prefix}-whatsapp-button`}
      >
        <a href={contact.whatsappLink} target="_blank" rel="noreferrer">
          <MessageCircle className="h-4 w-4" />
          {labels.whatsapp}
        </a>
      </Button>

      <Button
        asChild
        variant="outline"
        className="h-11 rounded-full border-primary/25 bg-white/80 transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-primary/5"
        data-testid={`${prefix}-call-button`}
      >
        <a href={contact.phoneLink}>
          <PhoneCall className="h-4 w-4 text-primary" />
          {labels.call}
        </a>
      </Button>
    </div>
  );
}